import dayjs from 'dayjs';
import { getDateFormatted } from './helpers/common.helper';
import moment from 'moment';

export const parseDate = (date: moment.MomentInput) =>
  moment(date).isValid() ? moment(date) : null;

export const formatDateColumn = (
  record: Parameters<typeof dayjs>[0],
  showTime = true
) =>
  record
    ? dayjs(record).format(
        `${getDateFormatted()}${showTime ? ' HH:mm:ss' : ''}`
      )
    : '';
